export default "__VITE_ASSET__piCIvMxv__"